module.exports = __webpack_public_path__ + "static/media/Sticker_On.ed48347a.png";